const fetch = require('utils/fetchRequest');

export const getVote = async () => {
    try {
        const response = await fetch.get('votes/web');

        return response.data;
    } catch (err) {
        return { error: err };
    }
};

export const answerVote = async (answerId) => {
    try {
        const response = await fetch.post('votes/answer', { answerId });
        return response;
    } catch (err) {
        return { error: err };
    }
};

export const getVoteList = async () => {
    try {
        const response = await fetch.get('votes');
        return response.data;
    } catch (err) {
        return { error: err };
    }
};

export const addVote = async (data) => {
    try {
        const response = await fetch.post('votes', data);
        return response;
    } catch (err) {
        return { error: err };
    }
};

export const deleteVote = async (id) => {
    try {
        const response = await fetch.destroy(`votes/${id}`);
        return response;
    } catch (err) {
        return { error: err };
    }
};

export const updateVote = async (id, newRow) => {
    try {
        const response = await fetch.put(`votes/${id}`, newRow);
        return response;
    } catch (err) {
        return { error: err };
    }
};
